<template>
  <div class="post">
    <div class="back-home" @click="backHome">&lt; &nbsp;&nbsp;返回首页</div>
    <div class="nav-user">
      <div class="user-info">
        <van-image
          round
          class="user-info-avatar"
          :src="data.user && data.user.headimgurl"
          fit="cover"
        />
        <div class="user-info-text">
          <div class="user-info-name">
            {{ data.user && data.user.nickname }}
            <van-image
              v-if="data.user && data.user.role === 1"
              class="official"
              fit="contain"
              :src="require('../../assets/img/profile-official.jpg')"
            />
          </div>
          <div class="user-info-sign">
            {{ data.user && data.user.level_msg }}
          </div>
        </div>
        <div
          class="user-info-attent"
          v-if="!(data.user && data.user.is_me)"
          @click="followClick"
        >
          {{ getIsFollow }}
        </div>
      </div>
      <div class="user-score"></div>
    </div>
    <div class="swipe">
      <van-swipe
        v-if="images.length > 0"
        class="my-swipe"
        :autoplay="3000"
        indicator-color="#D33A46"
      >
        <van-swipe-item
          v-for="(item, index) in images"
          :key="item.url"
          @click="onSwipeItemClick(index)"
        >
          <van-image class="van-swipe-item" :src="item.url" fit="contain" />
        </van-swipe-item>
      </van-swipe>
    </div>
    <!-- 视频播放器 -->
    <video-player
      v-for="item in videos"
      :key="item.sources.src"
      class="video-player vjs-custom-skin"
      ref="videoPlayer"
      :playsinline="true"
      :options="item"
    ></video-player>
    <!-- 帖子信息 -->
    <h3 class="post-title">{{ data.title }}</h3>
    <span
      class="relevance-active"
      v-for="item in data.keywords"
      :key="item.id"
      @click="avtiveClick(item.name)"
    >
      #{{ item.name }}#
    </span>
    <p class="post-text">
      {{ data.content }}
    </p>
    <!-- <p class="post-dosing">
      配料：面包片 草莓若干 荷兰豆 香蕉一根 丘比沙拉酱蛋黄口味
    </p> -->
    <div
      v-for="item in data.products"
      :key="item.name"
      class="post-goods"
      @click="goodsClick(item)"
    >
      <van-image class="post-goods-img" :src="item.image" fit="contain" />
      <div class="post-goods-info">
        <div class="goods-title">这道料理使用了：</div>
        <div class="goods-name">{{ item.name }}</div>
      </div>
    </div>

    <div class="post-updata-time">{{ data.updated_at + " 发布" }}</div>
    <div
      v-if="data.event_id == '7'"
      class="join-active"
      @click="sendPostClick()"
    >
      我要发帖
    </div>
    <div
      v-else-if="data.event_id == '8'"
      class="join-active"
      @click="findMoreClick()"
    >
      查看更多
    </div>
    <div
      v-else-if="data.event_id == '11'"
      class="join-active"
      @click="exchangeClick()"
    >
      我要兑换
    </div>
    <div
      v-else-if="[12, 21].includes(data.event_id)"
      class="join-active"
      @click="applyClick(data.event_id)"
    >
      我要报名
    </div>
    <div
      v-else-if="data.event_id == '15'"
      class="join-active"
      @click="joinClick"
    >
      我要参加
    </div>
    <div
      v-else-if="data.event_id == '16'"
      class="join-active"
      @click="joinAdClick"
    >
      我要参加
    </div>
    <div class="tab-back">
      <span>评论（{{ data.reply_count }})</span>
      <span>点赞（{{ data.like_count }})</span>
      <span>收藏（{{ data.favorite_count }}）</span>
    </div>
    <div class="comment">
      <div class="comment-field">
        <van-image
          class="comment-field-img"
          round
          :src="data.user && data.user.headimgurl"
          fit="cover"
        />
        <span @click="replyClick">喜欢这位丘粉分享， 就赶快评论下吧…</span>
        <van-popup
          v-model="replyShow"
          position="bottom"
          :style="{ height: '30%' }"
          @close="popupClose"
          @opened="popupOpened"
        >
          <div class="reply-file">
            <van-field
              ref="file"
              v-model="replyMessage"
              rows="3"
              autosize
              type="textarea"
              maxlength="150"
              placeholder="请输入评论"
              show-word-limit
            />
            <div class="reply-send" @click="replySendClick">发送</div>
          </div>
        </van-popup>
      </div>
      <!-- 评论列表 -->
      <van-list
        class="comment-list"
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
        offset="30"
      >
        <div
          class="comment-list-item"
          v-for="(item, index) in replies"
          :key="item.id"
        >
          <div class="comment-user">
            <van-image
              class="comment-list-avatar"
              round
              :src="item.user && item.user.headimgurl"
              fit="cover"
            />
            <div class="comment-list-user">
              <div class="comment-list-user-name">{{ item.user.nickname }}</div>
              <div class="comment-list-user-title">
                {{ item.user.level_msg }}
              </div>
            </div>
            <div class="comment-list-praise">
              <img
                :src="getCommentPraise(item.is_liked)"
                alt=""
                @click="praiseReplyClick(item)"
              />
              <p>{{ item.like_count }}</p>
            </div>
          </div>
          <div class="comment-text">
            <span class="comment-content">
              {{ item.content }}
            </span>
            <span class="comment-date">{{ item.created_at }}</span>
            <span class="comment-reaply" @click="replyClick(item.id, index)"
              >回复</span
            >
            <span
              v-if="IsShowDelete(item.user.id)"
              class="comment-delete"
              @click="deleteClick(item.id, index)"
              >删除</span
            >
          </div>
          <div class="comment-child" v-if="item.child_reply.length > 0">
            <div
              class="comment-child-item"
              v-for="(child, childIndex) in item.child_reply"
              :key="child.id"
            >
              <van-image
                class="comment-child-item-avatar"
                round
                :src="child.user && child.user.headimgurl"
                fit="cover"
              />
              <span class="comment-child-item-content"
                >{{ child.user.nickname }}：{{ child.content }}</span
              >
              <span
                v-if="IsShowDelete(child.user.id)"
                class="comment-child-item-content-delete"
                @click="deleteChildClick(index, child.id, childIndex)"
                >删除</span
              >
            </div>
          </div>
        </div>
      </van-list>
    </div>
    <div class="bottom-tab">
      <img
        class="bottom-tab-icon"
        src="~assets/img/post-tab-comment.png"
        alt=""
      />
      <van-field
        class="bottom-tab-field"
        placeholder="写评论"
        @click="replyClick"
      />
      <div class="bottom-tab-praise bottom-tab-item" @click="praiseClick">
        <img class="bottom-tab-icon" :src="getIsLike" alt="" />
        <span>点赞</span>
      </div>
      <div class="bottom-tab-collect bottom-tab-item" @click="collectClick">
        <img class="bottom-tab-icon" :src="getIsFavorited" alt="" />
        <span>收藏</span>
      </div>
    </div>
  </div>
</template>
<script>
import {
  getForums,
  userFollow,
  userUnFollow,
  likeTopic,
  unLikeTopic,
  favoriteTopic,
  unFavoriteTopic,
  sendReplies,
  getReplies,
  like_reply,
  unlike_reply,
  delete_reply,
  getWXInfo,
} from "network/home";

import qs from "qs";
import wx from "weixin-js-sdk";

import { ImagePreview } from "vant";

export default {
  name: "Post",
  components: {},
  props: {},
  data() {
    return {
      data: {},
      images: [], //图片数组
      videos: [], //视频数组
      replyShow: false,
      replyMessage: "",
      replies: [], //评论列表
      repliesPage: 0,
      parent_reply_id: 0, //当前回复的评论id
      parent_reply_index: 0, //当前回复的评论index
      loading: false, //加载中
      finished: false, //加载完成
      wxInfo: {}, //分享时需要的信息
    };
  },
  computed: {
    getIsFollow() {
      return this.data.user && this.data.user.is_followed ? "已关注" : "+关注";
    },
    getIsLike() {
      return this.data.is_liked
        ? require("../../assets/img/post-tab-praise.png")
        : require("../../assets/img/post-tab-unpraise.png");
    },
    getIsFavorited() {
      return this.data.is_favorited
        ? require("../../assets/img/post-tab-collect.png")
        : require("../../assets/img/post-tab-uncollect.png");
    },
    getCommentPraise() {
      return (isLike) => {
        return isLike
          ? require("../../assets/img/post-praise.png")
          : require("../../assets/img/post-unpraise.png");
      };
    },
    IsShowDelete() {
      return (userid) => {
        let userInfo = JSON.parse(localStorage.getItem("userInfo"));
        return userInfo.id === userid ? true : false;
      };
    },
  },
  created() {
    getForums(this.$route.query.id, this.$route.query.inviter_id).then(
      (res) => {
        this.data = res.data;
        this.getWXInfo();
        res.data.media_list.forEach((item) => {
          if (item.type == "image") {
            this.images.push(item);
          } else if (item.type == "video") {
            let playerOptions = {
              // playbackRates: [0.5, 1.0, 1.5, 2.0], // 可选的播放速度
              autoplay: false, // 如果为true,浏览器准备好时开始回放。
              muted: false, // 默认情况下将会消除任何音频。
              loop: false, // 是否视频一结束就重新开始。
              preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
              language: "zh-CN",
              aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
              fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
              sources: [
                {
                  type: "video/mp4", // 类型
                  src: "",
                },
              ],
              poster: "", // 封面地址
              notSupportedMessage: "此视频暂无法播放，请稍后再试", // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
              controlBar: {
                timeDivider: true, // 当前时间和持续时间的分隔符
                durationDisplay: true, // 显示持续时间
                remainingTimeDisplay: false, // 是否显示剩余时间功能
                fullscreenToggle: true, // 是否显示全屏按钮
              },
            };
            playerOptions.sources[0].src = item.file_url;
            this.videos.push(playerOptions);
          }
        });
      }
    );
  },

  methods: {
    //返回首页
    backHome() {
      this.$router.push({ path: "/home" });
    },
    //点击轮播
    onSwipeItemClick(index) {
      console.log(this.images);
      let images = [];
      this.images.forEach((item) => {
        images.push(item.url);
      });
      ImagePreview({
        images: images,
        startPosition: index,
      });
    },
    //发帖
    sendPostClick() {
      this.$router.push({ path: "/release" });
    },
    //查看更多
    findMoreClick() {
      window.location.href =
        "https://mp.weixin.qq.com/s/8OmWiLrdDTOc1UAeAeoQqQ";
    },
    //我要兑换
    exchangeClick() {
      window.location.href =
        "https://kpc.cowsms.com/kewpiefansclub/#/malldetail?id=15";
    },
    //活动报名
    applyClick(event_id) {
      if (event_id == 12) {
        this.$router.push({
          path: "/homepostapply",
          query: {
            event_id,
          },
        });
      } else if (event_id == 21) {
        //调查问卷
        this.$router.push({
          path: "/homepostquestionnaire",
          query: {
            event_id,
          },
        });
      }
    },
    //id=15 我要参加
    joinClick() {
      //调查问卷
      // this.$router.push({
      //   path: "/homepostquestionnaire",
      //   query: {
      //     event_id: 21,
      //   },
      // });
      window.location.href =
        "https://quiz.kewpie.com.cn/index.html?utm_source=wechataccount&utm_medium=cpc&utm_campaign=321mobgame";
    },
    //id == 16
    joinAdClick() {
      window.location.href = "https://m.tb.cn/h.gWSMrybPkwUyiyd";
    },
    //关注或取消关注
    followClick() {
      let params = { user_id: this.data.user.id };
      if (this.data.user.is_followed) {
        userUnFollow(qs.stringify(params)).then((res) => {
          this.data.user.is_followed = !this.data.user.is_followed;
        });
      } else {
        userFollow(qs.stringify(params)).then((res) => {
          this.data.user.is_followed = !this.data.user.is_followed;
        });
      }
    },
    //点击关联商品
    goodsClick(item) {
      if (item.jd_buy_link.length) window.location.href = item.jd_buy_link;
    },
    //popupClose
    popupClose() {
      this.parent_reply_id = 0;
      this.parent_reply_index = 0;
      this.replyMessage = "";
    },
    //popupOpened
    popupOpened() {
      this.$refs.file.focus();
    },
    //点赞
    praiseClick() {
      let params = { topic_id: this.data.id };
      if (this.data.is_liked) {
        unLikeTopic(qs.stringify(params)).then((res) => {
          this.data.is_liked = !this.data.is_liked;
          this.data.like_count -= 1;
        });
      } else {
        likeTopic(qs.stringify(params)).then((res) => {
          this.data.is_liked = !this.data.is_liked;
          this.data.like_count += 1;
        });
      }
    },
    //收藏
    collectClick() {
      let params = { topic_id: this.data.id };
      if (this.data.is_favorited) {
        unFavoriteTopic(qs.stringify(params)).then((res) => {
          this.data.is_favorited = !this.data.is_favorited;
          this.data.favorite_count -= 1;
        });
      } else {
        favoriteTopic(qs.stringify(params)).then((res) => {
          this.data.is_favorited = !this.data.is_favorited;
          this.data.favorite_count += 1;
        });
      }
    },

    //点赞回帖
    praiseReplyClick(item) {
      let params = { reply_id: item.id };
      if (item.is_liked) {
        unlike_reply(qs.stringify(params)).then((res) => {
          item.is_liked = !item.is_liked;
          item.like_count -= 1;
        });
      } else {
        like_reply(qs.stringify(params)).then((res) => {
          item.is_liked = !item.is_liked;
          item.like_count += 1;
        });
      }
    },
    //展示评论
    replyClick(parent_reply_id, index) {
      this.replyShow = true;
      this.parent_reply_id = parent_reply_id;
      this.parent_reply_index = index;
    },
    //删除评论
    deleteClick(id, index) {
      delete_reply(id).then((res) => {
        this.replies.splice(index, 1);
      });
    },
    //删除回复
    deleteChildClick(index, childId, childIndex) {
      delete_reply(childId).then((res) => {
        this.replies[index].child_reply.splice(childIndex, 1);
      });
    },
    //点击话题
    avtiveClick(activeName) {
      this.$router.push({
        path: "/search",
        query: {
          searchText: activeName,
        },
      });
    },

    //发送评论
    replySendClick() {
      this.replyShow = true;
      let params = { topic_id: this.data.id };
      if (this.replyMessage.length === 0) {
        this.$toast("请输入评论");
        return;
      } else {
        params.content = this.replyMessage;
      }

      if (this.parent_reply_id > 0) {
        //评论的恢复
        params.parent_reply_id = this.parent_reply_id;
      }
      sendReplies(qs.stringify(params)).then((res) => {
        let item = this.replies[this.parent_reply_index];
        if (item) {
          if (item.id === this.parent_reply_id) {
            item.child_reply.push(res.data);
          }
        } else {
          this.replies.push(res.data);
        }

        this.replyShow = false;
        this.parent_reply_id = 0;
        this.parent_reply_index = 0;
        this.replyMessage = "";
      });
    },
    //会帖列表
    getTopicReplies() {
      this.repliesPage++;
      let params = { topic_id: this.$route.query.id, page: this.repliesPage };
      getReplies(params).then((res) => {
        if (res.data.length > 0) {
          this.replies = this.replies.concat(res.data);
          this.loading = false;
        } else {
          this.loading = false;
          this.finished = true;
        }
      });
    },
    onLoad() {
      this.getTopicReplies();
    },
    getWXInfo() {
      var that = this;
      let url = window.location.href.split("#")[0];
      let imageIcon = this.data.user.headimgurl;

      // if (this.images.length > 0) {
      //   imageIcon = this.images[0].url;
      // } else {
      //   imageIcon = ;
      // }

      getWXInfo(url).then((res) => {
        let wxInfo = res;
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: wxInfo.appId, // 必填，公众号的唯一标识
          timestamp: wxInfo.timestamp, // 必填，生成签名的时间戳
          nonceStr: wxInfo.nonceStr, // 必填，生成签名的随机串
          signature: wxInfo.signature, // 必填，签名
          jsApiList: ["updateAppMessageShareData", "updateTimelineShareData"], // 必填，需要使用的JS接口列表
        });

        wx.ready(function () {
          //需在用户可能点击分享按钮前就先调用
          wx.updateAppMessageShareData({
            title: that.data.title, // 分享标题
            desc: that.data.content, // 分享描述
            link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: imageIcon, // 分享图标
            success: function () {
              // 设置成功
            },
          });
          wx.updateTimelineShareData({
            title: that.data.title, // 分享标题
            link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: imageIcon, // 分享图标, // 分享图标
            success: function () {
              // 设置成功
            },
          });
        });
        wx.error(function (err) {
          console.log(err);
        });
      });
    },
  },
  mounted() {
    // const s = document.createElement("script");
    // s.type = "text/javascript";
    // s.src = "http://res.wx.qq.com/open/js/jweixin-1.6.0.js";
    // document.body.appendChild(s);
  },
  watch: {},
};
</script>
<style scoped>
.post {
  padding: 20px 15px 15px 15px;

  background: #fff;
}
.back-home {
  height: 40px;
  font-weight: bold;
  color: var(--color-main);
}
.user-info {
  display: flex;
}
.user-info-avatar {
  width: 50px;
  height: 50px;
  border-radius: 30px;
  border: 1px solid #707070;
}
.user-info-text {
  flex: 1;
  margin-left: 5px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.user-info-name {
  font-size: 14px;
  font-weight: 700;
}
.official {
  margin-left: 7px;
  width: 52px;
  height: 14px;
}
.user-info-sign {
  font-size: 13px;
}
.user-info-attent {
  align-self: center;
  width: 70px;
  height: 25px;
  line-height: 25px;
  text-align: center;
  border-radius: 5px;
  background-color: var(--color-main);
  font-size: 13px;
  color: #fff;
}
.swipe {
  overflow: hidden;
  padding-bottom: 20px;
}
::v-deep .van-swipe {
  overflow: visible;
}
::v-deep .van-swipe__indicators {
  bottom: -20px;
}
::v-deep .van-swipe__indicator {
  background-color: #707070;
}

.my-swipe {
  margin-top: 20px;
}
.my-swipe .van-swipe-item {
  height: 258px;
  width: 345px;
  font-size: 20px;
  text-align: center;
}
.video-player {
  margin: 15px 0;
  width: 100%;
  height: 100%;
}
.post-title {
  margin-top: 10px;
  font-size: 14px;
}
.relevance-active {
  margin-top: 5px;
  margin-right: 10px;
  font-size: 14px;
  color: var(--color-main);
}
.post-text {
  margin-top: 10px;
  white-space: pre-line;
  font-size: 12px;
  color: #707070;
}
.post-dosing {
  margin-top: 10px;
  font-size: 12px;
  color: #707070;
}

.post-goods {
  margin-top: 20px;
  display: flex;
  align-items: center;
  background-color: #f2f2f2;
  border-radius: 10px;
}
.post-goods-img {
  margin: 10px 10px 10px 10px;
  width: 80px;
  height: 55px;
}
.goods-title {
  font-size: 12px;
  font-weight: 500;
  color: var(--color-main);
}
.goods-name {
  font-size: 14px;
  font-weight: 500;

  color: var(--color-main);
}
.join-active {
  margin: 15px auto;
  width: 100px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  border-radius: 5px;
  font-size: 14px;
  color: #fff;
  background-color: var(--color-main);
}
.post-updata-time {
  margin-top: 10px;
  font-size: 13px;
  color: #707070;
}
.tab-back {
  margin-top: 10px;
  padding-bottom: 10px;
  display: flex;
  justify-content: center;
  font-size: 13px;
  font-weight: 500;
  border-bottom: 1px solid #e5e5e5;
}
.tab-back span {
  margin: 5px;
}
.comment {
  padding: 10px 0 50px 0px;
}
.comment-field {
  display: flex;
  align-items: center;
  margin: 10px 0 20px 0;
}
.comment-field-img {
  width: 40px;
  height: 40px;
  border-radius: 20px;
  background-color: aqua;
  border: 1px solid #707070;
}
.comment-field span {
  flex: 1;
  margin-left: 10px;
  padding: 0 10px;
  height: 30px;
  line-height: 30px;
  border-radius: 10px;
  font-size: 12px;
  background-color: #f2f2f2;
  color: #707070;
}
.comment-list {
  min-height: 100px;
}
.comment-list-item {
  padding-bottom: 20px;
  border-bottom: 1px solid #e5e5e5;
}
.comment-user {
  margin-top: 10px;
  display: flex;
}
.comment-list-avatar {
  width: 40px;
  height: 40px;
}
.comment-list-user {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: 20px;
}
.comment-list-user-name {
  font-size: 14px;
  font-weight: 500;
}
.comment-list-user-title {
  font-size: 12px;
  color: #707070;
}
.comment-list-praise {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.comment-list-praise img {
  width: 15px;
  height: 15px;
}
.comment-list-praise p {
  font-size: 10px;
  color: #707070;
}
.comment-reaply {
  padding: 0 10px;
  font-size: 12px;
  color: #1e90ff;
}
.comment-delete {
  margin-left: 5px;
  font-size: 12px;
  color: var(--color-main);
}
.comment-text {
  margin-top: 10px;
  margin-left: 59px;
  line-height: 1.2;
  margin-right: 20px;
}
.comment-content {
  font-size: 13px;
  color: #707070;
}
.comment-date {
  font-size: 10px;
  color: #b1b1b1;
}
.comment-child {
  margin: 15px 30px 15px 50px;
  border-radius: 2px;
  padding: 10px 10px;
  background-color: #f0f0f0;
}
.comment-child-item {
  margin-bottom: 5px;
}
.comment-child-item-avatar {
  width: 20px;
  vertical-align: middle;
  height: 20px;
}
.comment-child-item-content {
  margin-left: 10px;
  font-size: 12px;
  color: #707070;
}
.comment-child-item-content-delete {
  margin-left: 5px;
  font-size: 12px;
  color: var(--color-main);
}
.bottom-tab {
  position: fixed;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  padding: 0 10px;
  box-shadow: 0 -1px 3px rgba(133, 133, 133, 0.3);
  width: 100%;
  height: 55px;
  background-color: #f2f2f2;
}
.bottom-tab img {
  margin-left: 10px;
  width: 20px;
  height: 20px;
}
.bottom-tab span {
  margin-left: 5px;
}
::v-deep .van-cell {
  padding: 2px 5px 2px 5px;
  background-color: #f2f2f2;
}
.bottom-tab-field {
  flex: 1;
  margin-left: 5px;
  height: 30px;
  border-bottom: 1px solid #707070;
}
.bottom-tab-item {
  display: flex;
  align-items: center;
  font-size: 14px;
}
.reply-file {
  margin: 15px;
}
.reply-send {
  margin: 10px auto;
  line-height: 25px;
  text-align: center;
  width: 60px;
  height: 25px;
  color: #fff;
  font-size: 14px;
  border-radius: 5px;
  background-color: var(--color-main);
}
</style>